/**
 * Helpers for reading the base64/JSON encoded values the app keeps in sessionStorage.
 * They replace the same few lines that used to be repeated in every component.
 */

/** Reads `key`, stored as JSON.stringify(btoa(JSON.stringify(value))), and returns `value` (or null). */
export function readEncodedSession(key: string): any {
  const stored = sessionStorage.getItem(key);
  const base64 = stored ? JSON.parse(stored) : null;
  return base64 ? JSON.parse(atob(base64)) : null;
}

/** Reads `key`, stored as btoa(JSON.stringify(value)), and returns `value` (or null). */
export function readBase64Session(key: string): any {
  const stored = sessionStorage.getItem(key);
  const decoded = stored ? atob(stored) : null;
  return decoded ? JSON.parse(decoded) : null;
}

/** Id of the logged in user (the "UserID" entry is base64 of a JSON value). */
export function readSessionUserId(): any {
  return JSON.parse(atob(sessionStorage.getItem('UserID') ?? 'null'));
}

/** Investor account id (the "AccountID" entry is the base64 of the numeric id), or null when absent. */
export function readSessionAccountId(): number | null {
  const stored = sessionStorage.getItem('AccountID');
  return stored ? Number(atob(stored)) : null;
}

/** Investor onboarding mode ("InvestorModefolio"): a base64 encoded number, optionally JSON encoded first. */
export function readInvestorMode(): number | null {
  const storedMode = sessionStorage.getItem('InvestorModefolio');
  let selectedMode: number | null = null;

  if (storedMode) {
    try {
      selectedMode = Number(JSON.parse(atob(storedMode)));
    } catch {
      try {
        selectedMode = Number(atob(storedMode));
      } catch (e) {
        console.error('Error parsing InvestorModefolio:', e);
      }
    }
  }

  return selectedMode;
}
